import AnalyticsCompanyItemPagingResultModelBase from '../_generated/modelBases/analytics-company-item-paging-result-model-base';

export default class AnalyticsCompanyItemPagingResultModel extends AnalyticsCompanyItemPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
